import styled from 'styled-components'

import theme from 'theme_'
import { GreyMiniBlock } from 'components/Layout'
import { Body12 } from 'components/Typography'

const { spacing } = theme

export const ConnectedAppContainer = styled(GreyMiniBlock).attrs({ as: 'li' })`
  padding: ${spacing.xs};
  margin: 0;
  overflow: hidden;
`

export const ConnectedAppIconContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const ConnectedAppIconImg = styled.img`
  height: 60px;
  max-width: 100%;
`

export const ConnectedAppStatusText = styled(Body12)`
  padding-top: ${spacing.xs};
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    height: 0.75rem;
    margin-left: 0.25rem;
    width: 0.75rem;
  }
`
